export const getNoteStyles = ({ isDeleted }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  width: '100%',
  border: ({ palette }) => `1px solid ${isDeleted ? palette.border.input : palette.border.default}`,
  borderRadius: '8px',
  padding: '12px',
});

export const noteContentWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  minWidth: 0,
};

export const noteTextStyles = {
  overflowWrap: 'break-word',
};

export const noteMetadataStyles = {
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
};

export const noteContentWithMenuStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: '8px',
  width: '100%',
};

export const editFormStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  width: '100%',
};

export const saveButtonWrapperStyles = {
  display: 'flex',
  gap: '8px',
  justifyContent: 'flex-end',
};
